import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { NgSelectModule } from "@ng-select/ng-select";

import { CustomSelectFieldComponent } from "./custom-select-field/custom-select-field.component";
import { CustomTextFieldComponent } from "./custom-text-field/custom-text-field.component";
import { CustomFieldComponent } from "./custom-field.component";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { CorePipesModule } from "@core/pipes/pipes.module";

@NgModule({
  declarations: [
    CustomSelectFieldComponent,
    CustomTextFieldComponent,
    CustomFieldComponent,
  ],
  imports: [CommonModule, FormsModule, NgSelectModule,TranslateModule,CorePipesModule],

  exports: [
    CustomSelectFieldComponent,
    CustomTextFieldComponent,
    CustomFieldComponent
    
  ],
})
export class CustomFieldModule { }
